export type AreaChargeMultiPolygon = {
  type: 'MultiPolygon';
  coordinates: number[][][][];
};

/** Leaflet reports a loaded MultiPolygon as one layer. Keep every polygon in it. */
export function convertGeometryToPolygonRings(geometry: {
  type: string;
  coordinates: number[][][] | number[][][][];
}): number[][][][] {
  if (geometry.type === 'Polygon') return [geometry.coordinates as number[][][]];
  if (geometry.type === 'MultiPolygon') return geometry.coordinates as number[][][][];
  return [];
}

/** Copies each drawn polygon, including cut-tool holes, into one MultiPolygon. */
export function convertPolygonsToMultiPolygon(
  polygons: number[][][][],
): AreaChargeMultiPolygon | null {
  if (!polygons.length) return null;
  return {
    type: 'MultiPolygon',
    coordinates: polygons,
  };
}

export function isAreaChargeMultiPolygon(value: unknown): value is AreaChargeMultiPolygon {
  return (
    typeof value === 'object' &&
    value !== null &&
    'type' in value &&
    value.type === 'MultiPolygon' &&
    'coordinates' in value &&
    Array.isArray(value.coordinates)
  );
}
